
var StoryModelEvent = {};
export default StoryModelEvent;

StoryModelEvent.START_STATE_CHANGED = "START_STATE_CHANGED";
/**
 * The StoryModelEvent.STORY_ARC_ADDED constant defines the value of the 
 * <code>type</code> property of the event object 
 * for a <code>STORY_ARC_ADDED</code> event.
 *
 * <p>The properties of the StoryPlayerEvent have the following values:</p>
 * <table class=innertable>
 * <tr><th>Property</th><th>Value</th></tr>
 * <tr><td>storyArc</td><td>The added IStoryArc</td></tr>
 * <tr><td>storyNode</td><td>null</td></tr>
 * </table>
 *
 * @eventType STORY_ARC_ADDED
 */
StoryModelEvent.STORY_ARC_ADDED = "STORY_ARC_ADDED";
/**
 * The StoryModelEvent.STORY_ARC_REMOVED constant defines the value of the 
 * <code>type</code> property of the event object 
 * for a <code>STORY_ARC_REMOVED</code> event.
 *
 * <p>The properties of the StoryPlayerEvent have the following values:</p>
 * <table class=innertable>
 * <tr><th>Property</th><th>Value</th></tr>
 * <tr><td>storyArc</td><td>The removed IStoryArc</td></tr>
 * <tr><td>storyNode</td><td>null</td></tr>
 * </table>
 *
 * @eventType STORY_ARC_REMOVED
 */
StoryModelEvent.STORY_ARC_REMOVED = "STORY_ARC_REMOVED";
/**
 * The StoryModelEvent.STORY_ARC_UPDATED constant defines the value of the 
 * <code>type</code> property of the event object 
 * for a <code>STORY_ARC_UPDATED</code> event.
 *
 * <p>The properties of the StoryPlayerEvent have the following values:</p>
 * <table class=innertable>
 * <tr><th>Property</th><th>Value</th></tr>
 * <tr><td>storyArc</td><td>The updated IStoryArc</td></tr>
 * <tr><td>storyNode</td><td>null</td></tr>
 * </table>
 *
 * @eventType STORY_ARC_UPDATED
 */
StoryModelEvent.STORY_ARC_UPDATED = "STORY_ARC_UPDATED";
/**
 * The StoryModelEvent.STORY_NODE_ADDED constant defines the value of the 
 * <code>type</code> property of the event object 
 * for a <code>STORY_NODE_ADDED</code> event.
 *
 * <p>The properties of the StoryPlayerEvent have the following values:</p>
 * <table class=innertable>
 * <tr><th>Property</th><th>Value</th></tr>
 * <tr><td>storyArc</td><td>The IStoryArc the IStoryNode was added to</td></tr>
 * <tr><td>storyNode</td><td>The added IStoryNode</td></tr>
 * </table>
 *
 * @eventType STORY_NODE_ADDED
 */
StoryModelEvent.STORY_NODE_ADDED = "STORY_NODE_ADDED";
/**
 * The StoryModelEvent.STORY_NODE_REMOVED constant defines the value of the 
 * <code>type</code> property of the event object 
 * for a <code>STORY_NODE_REMOVED</code> event.
 *
 * <p>The properties of the StoryPlayerEvent have the following values:</p>
 * <table class=innertable>
 * <tr><th>Property</th><th>Value</th></tr>
 * <tr><td>storyArc</td><td>The IStoryArc the IStoryNode was in</td></tr>
 * <tr><td>storyNode</td><td>The removed IStoryNode</td></tr>
 * </table>
 *
 * @eventType STORY_NODE_REMOVED
 */
StoryModelEvent.STORY_NODE_REMOVED = "STORY_NODE_REMOVED";
/**
 * The StoryModelEvent.STORY_NODE_UPDATED constant defines the value of the 
 * <code>type</code> property of the event object 
 * for a <code>STORY_NODE_UPDATED</code> event.
 *
 * <p>The properties of the StoryPlayerEvent have the following values:</p>
 * <table class=innertable>
 * <tr><th>Property</th><th>Value</th></tr>
 * <tr><td>storyArc</td><td>null</td></tr>
 * <tr><td>storyNode</td><td>The updated IStoryNode</td></tr>
 * </table>
 *
 * @eventType STORY_NODE_UPDATED
 */
StoryModelEvent.STORY_NODE_UPDATED = "STORY_NODE_UPDATED";
/**
 * The StoryModelEvent.STORY_ELEMENT_UPDATED constant defines the value of the 
 * <code>type</code> property of the event object 
 * for a <code>STORY_ELEMENT_UPDATED</code> event.
 *
 * <p>The properties of the StoryPlayerEvent have the following values:</p>
 * <table class=innertable>
 * <tr><th>Property</th><th>Value</th></tr>
 * <tr><td>storyArc</td><td>null</td></tr>
 * <tr><td>storyNode</td><td>null</td></tr>
 * </table>
 *
 * @eventType STORY_ELEMENT_UPDATED
 */
StoryModelEvent.STORY_ELEMENT_UPDATED = "STORY_ELEMENT_UPDATED";